import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await fetch(`${URI_TARIFF_PLAN}tariff-plan`, opts);

  const jsonResult = await response.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult;
};
